module.exports = __webpack_public_path__ + "Flama-Ultralight.woff2?557b8a42bb68b21e4b5c872e8f1bde5b";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Ultralight.woff2
// module id = 920
// module chunks = 0